import voucherObject from './main'

const voucherPopupArray = (voucher) => {
    Object.keys(voucherObject).forEach(key => {
        voucherObject[key].value = voucherObject[key].custom ?
            voucherObject[key].custom(voucher) :
            voucher[voucherObject[key].accessor]
        if (!voucherObject[key].value) {
            voucherObject[key].value = 'אין מידע'
        }
    })
    return {
        voucherType: voucherObject.voucherType.value,
        detailsArrCol1: [
            voucherObject.createdAt,
            // voucherObject.create_by,
            voucherObject.updatedAt,
            // voucherObject.update_by,
        ].map(field => `${field.Header}: ${field.value}`),
        detailsArrCol2: [
            voucherObject.barcode,
        ].map(field => `${field.Header}: ${field.value}`),
    }
}

export default voucherPopupArray
